// Sort options for the enrollments list (sent as the `sort` query param).
// See ClickUp 868jxkz4p §3. Built from the caller's `t` so the labels follow
// the active language.
export const getEnrollmentSorts = (t) => [
  { id: "started_at_desc", label: t("enrollmentSorts.startedAtDesc") },
  { id: "started_at_asc", label: t("enrollmentSorts.startedAtAsc") },
  { id: "members_count_desc", label: t("enrollmentSorts.membersCountDesc") },
  { id: "members_count_asc", label: t("enrollmentSorts.membersCountAsc") },
  { id: "revenue_desc", label: t("enrollmentSorts.revenueDesc") },
  { id: "ends_at_asc", label: t("enrollmentSorts.endsAtAsc") },
  { id: "split_ends_at_asc", label: t("enrollmentSorts.splitEndsAtAsc") },
];

export const DEFAULT_ENROLLMENT_SORT = "started_at_desc";

export const getEnrollmentSortLabel = (t) =>
  getEnrollmentSorts(t).reduce(
    (acc, sort) => ({ ...acc, [sort.id]: sort.label }),
    {}
  );
